import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import "@/utils/resize.js";
import "@/assets/style/reset.scss";
import "@/assets/style/base.scss";
import "@/assets/style/font-face.scss";
import "@/assets/style/marketing.scss";
import App from "./App.vue";
import router from "./router";

import AnimateEnterDirective from "@/utils/animate/v-animate-enter";
import FlyRight from "@/utils/animate/v-fly-right";
import VueLazyload from "vue3-lazyload";

import i18n from "@/i18n";
import { initLocale } from "@/i18n/locale";

const app = createApp(App);

app.use(VueLazyload, {});
app.directive("animate-enter", AnimateEnterDirective);
app.directive("fly-right", FlyRight);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

initLocale(); // 读持久化的 userInfo.language 设定初始 locale
app.use(i18n).use(router).mount("#app");
